<template>
	<modal titulo="Odin - Resumo Inteligente de Anexo" :loading="loading">

    <card v-if="!loading">
      <div class="row gutters-xs form">
        <div class="col">
          <span class="float-right">
            <odin-informar-erro :referencia="referencia" :tipo="tipo" />
          </span>
        </div>
        <div class="w-100"></div>
        <div class="col" id="odin-resumo-anexo" v-if="tipo == 'ANALISE_DOCUMENTO'">
          <odin-documento-detalhes-component :documento-detalhes="resposta" />
        </div>
      </div>
    </card>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-2">Fechar</button>
    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import Card from "@/components/Layout/components/Card.vue";
import Modal from "@/components/Modal";
import OdinDocumentoDetalhesComponent from "@/views/Odin/componentes/OdinDocumentoDetalhesComponent.vue";
import OdinInformarErro from "@/views/Odin/componentes/OdinInformarErro.vue";
import TextExtractorBusiness from "@/views/Odin/componentes/TextExtractorBusiness";

export default {
  name: "ModalOdinResumoDocumento",
  components: {OdinDocumentoDetalhesComponent, OdinInformarErro, Card, Modal},
  props: {
    tipo : String,
    referencia : String
  },
  data() {
    return {
      loading: true,
      resposta: null
    }
  },

  modal:{
    width: 1200,
    escapable: false
  },

  mounted() {
      this.run();
  },

  computed:{
  },

  methods:{

      close() {
        FrontBusiness.closeModal();
      },

      async run() {
        this.resposta = await TextExtractorBusiness.ocrDocumento(this.tipo, null, this.referencia)
          .catch(e => FrontBusiness.showError('', e.message));
        this.$set(this, 'loading', false);
      },
    }
  }
</script>

<style lang=scss>
#odin-resumo-anexo{
  h3{
    font-size: 1.4rem;
  }
  h4{
    font-size: 1.1rem;
    margin-top: 20px;
  }
}
</style>
